import React from 'react';
const Loader = () => {
  return (
    <div className="loader-wrapper">
      <div className="loader">
        <div className="lds-ellipsis">
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
      </div>
    </div>
  );
};

export default Loader;
